/**
 * Replay Loading Modal - Standalone Fullscreen Loading Overlay
 * Shows a frosted glass loading screen while replay data is being fetched
 */
export class ReplayLoadingModal {
  constructor() {
    this.overlay = null;
    this.isVisible = false;
    this.init();
  }

  /**
   * Initialize the loading modal
   */
  init() {
    console.log('⏳ ReplayLoadingModal: Initializing...');
    this.createModal();
  }

  /**
   * Create the loading modal DOM structure
   */
  createModal() {
    // Create fullscreen overlay
    const overlay = document.createElement('div');
    overlay.className = 'replay-loading-modal';
    overlay.id = 'replay-loading-modal';
    
    overlay.innerHTML = `
      <div class="replay-loading-content">
        <div class="replay-loading-spinner-large">
          <div class="spinner-large"></div>
        </div>
        <h3 class="replay-loading-title">Loading Replay Data</h3>
        <p class="replay-loading-message">Fetching flight telemetry and preparing playback...</p>
      </div>
    `;

    document.body.appendChild(overlay);
    this.overlay = overlay;
  }

  /**
   * Show the loading modal
   */
  show() {
    if (this.isVisible) return;
    
    this.isVisible = true;
    this.overlay.classList.add('visible');
    console.log('⏳ ReplayLoadingModal: Shown');
  }

  /**
   * Hide the loading modal
   */
  hide() {
    if (!this.isVisible) return;
    
    this.isVisible = false;
    this.overlay.classList.remove('visible');
    console.log('⏳ ReplayLoadingModal: Hidden');
  }

  /**
   * Update the loading message
   */
  setMessage(message) {
    const messageEl = this.overlay.querySelector('.replay-loading-message');
    if (messageEl) {
      messageEl.textContent = message;
    }
  }

  /**
   * Clean up
   */
  destroy() {
    if (this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }
    this.overlay = null;
    this.isVisible = false;
  }
}
